

import {Component, Vue, Prop} from "vue-property-decorator";

import { SessionManager } from "@/components/utils/utils";
import Tooltip from "@/components/survey/Tooltip.vue";
import LegalAssistanceFaq from "@/components/utils/LegalAssistanceFaq.vue";
import Checklists from "./checklists/Checklists.vue";

import {whichCaseMgmtForm} from "@/components/steps/caseMgmt/reviewCM/RequiredForm"
import {whichAgreementEnfrcForm} from '@/components/steps/agreementEnfrc/reviewAE/RequiredFormEnfrc'
import { GetFilingLocations } from "@/components/status/GetFilingLocations";

@Component({
    components:{        
        Tooltip,
        LegalAssistanceFaq,
        Checklists
    }
})
export default class SuccessPage extends Vue {
    
    @Prop({required: true})
    packageInfo!: any;

    packageNumber = "";
    packageUrl="";

    mountedData = false;
    showLegalAssistance = false;

    checklist = false;
    checklistType='';
    applicationId = '';
    applicationDocumentTypes = [];
    // Removed "REF" in otherApplicationTypes array as per https://jira.justice.gov.bc.ca/browse/PFCF-539
    otherApplicationTypes = ['NCD', 'NDT', 'NLC', 'NLP', 'NP', 'NLCR', 'NLPR', 'ORD', 'RFS', 'RPS'];
    includesOtherForms = false;

    otherApplicationTypesInfo = [        
        {name:'NCD',    title:'Notice of Address Change'},
        {name:'NPR',    title:'Notice of Intention to Proceed'},
        {name:'NDT',    title:'Notice of Discontinuance'},
        {name:'NLC',    title:'Notice of Lawyer for Child'},
        {name:'NLP',    title:'Notice of Lawyer for Party'},
        {name:'NP',     title:'Notice of Participation'},
        {name:'NLCR',   title:'Notice of Removal of Lawyer for Child'},
        {name:'NLPR',   title:'Notice of Removal of Lawyer for Party'},
        {name:'ORD',    title:'Order – General'},
        // Removed "REF" in otherApplicationTypesInfo array as per https://jira.justice.gov.bc.ca/browse/PFCF-539
        // {name:'REF',    title:'Referral Request'},
        {name:'RFS',    title:'Request for Service of Documents'},
        {name:'RPS',    title:'Request for Service of Family Protection Order'}
    ];  
        
    public viewStatus() {
        this.$router.push({ name: "applicant-status" });
    }
    
    public exitApplication() {
        window.open('http://www.google.ca');
        SessionManager.logoutAndRedirect(this.$store);
    }
    
    mounted(){
        this.mountedData = false;
        this.applicationId = this.packageInfo.fileNumber;
        this.packageUrl = this.packageInfo.eFilingUrl;
        this.packageNumber = this.packageInfo.packageNumber;
        this.includesOtherForms = false;

        this.saveApplication(this.applicationId, this.packageNumber, this.packageUrl);
    }

    public saveApplication(id, packagenumber, packageurl) {
        
        const data = {
            packageNumber: packagenumber,
            packageUrl: packageurl 
        } 

        const url = "/efiling/"+id+"/submit/";

        const header = {
            responseType: "json",
            headers: {
                "Content-Type": "application/json",
            }
        }

        this.$http.put(url, data, header)
        .then(res => {                                       
            this.getApplicationTypes(id);
        }, err => {
            console.error(err);
        });    
    }

    public async getApplicationTypes(applicationId: string) {

        await GetFilingLocations(); 

        this.$http.get('/app/'+ applicationId + '/')
        .then((response) => {

            const applicationData = response.data;
            const stepGETSTART = this.getStepResultByName(applicationData, 'GETSTART');
            const stepCOMM = this.getStepResultByName(applicationData, 'COMMON');
            const stepCM = this.getStepResultByName(applicationData, 'CM');
            const stepENFRC = this.getStepResultByName(applicationData, 'ENFRC');

            let pathways: string[] = [];            

            const includesOrderActivities = stepGETSTART?.selectedActivity.includes('applyForOrder');
            const includesReplyActivities = stepGETSTART?.selectedActivity.includes('replyToApplication');

            const selectedForms = (includesOrderActivities && stepGETSTART?.selectedForms)?stepGETSTART.selectedForms:[];

            const selectedReplyForms = (includesReplyActivities && stepGETSTART?.selectedReplyForms)?stepGETSTART.selectedReplyForms:[];
         
            pathways = selectedForms.concat(selectedReplyForms);              

            const includesFlm = pathways.includes('familyLawMatter');
            const includesEnfrc = pathways.includes('agreementEnfrc');
            const includesCm = pathways.includes('caseMgmt');

            if (pathways.includes('protectionOrder')){
                this.applicationDocumentTypes.push('AAP')
            }

            if (pathways.includes('priorityParenting')){
                this.applicationDocumentTypes.push('AXP')
            }

            if (pathways.includes('childReloc')){
                this.applicationDocumentTypes.push('APRC')
            }

            if (pathways.includes('writtenResponse')){
                this.applicationDocumentTypes.push('WRA')
            }

            if (pathways.includes('replyFlm')){
                this.applicationDocumentTypes.push('RFLM')
            }

            //TODO: may need to remove this

            if (pathways.includes('noticeDiscontinuance')){
                this.applicationDocumentTypes.push('NDT')
            }

            //TODO: adjust based on new file types            

            if (includesFlm){

                const applicationLocationName = applicationData.applicationLocation?applicationData.applicationLocation:'';

                if (Vue.filter('includedInRegistries')(applicationLocationName, 'early-resolutions')
                    && (stepCOMM?.filingLocationSurvey?.data?.MetEarlyResolutionRequirements == 'n')){

                    this.applicationDocumentTypes.push('NTRF');

                } else {

                    this.applicationDocumentTypes.push('FLC');

                }
                console.log(applicationLocationName)
            }

            if (includesCm){
                const CMforms = whichCaseMgmtForm(stepCM);
                if(CMforms?.includes("P10")) this.applicationDocumentTypes.push('ACMO');
                if(CMforms?.includes("P11")) this.applicationDocumentTypes.push('ACMW');
            }

            if (includesEnfrc){
                const EnfrcForm = whichAgreementEnfrcForm(stepENFRC);
                if(EnfrcForm?.includes('P29')) this.applicationDocumentTypes.push('AFET');
                if(EnfrcForm?.includes('P26')) this.applicationDocumentTypes.push('RFA');
                if(EnfrcForm?.includes('P27')) this.applicationDocumentTypes.push('RDET');
                if(EnfrcForm?.includes('P28')) this.applicationDocumentTypes.push('RORD');
            } 
            
            if (pathways.length == 0 && stepGETSTART?.otherForms){                
                this.applicationDocumentTypes = stepGETSTART?.submittedPdfList? stepGETSTART.submittedPdfList:[];

                // this.includesOtherForms = this.otherApplicationTypes.some(otherAppType => this.applicationDocumentTypes.includes(otherAppType))
                
            }            

            this.mountedData = true;

        }, err => {
            this.mountedData = true;        
        });        
   
    }

    public getStepResultByName(applicationData, stepName){
        if(applicationData?.steps){
            const steps = applicationData.steps.filter(step => step.name == stepName);
            if(steps.length == 1) return steps[0].result
        }
        return {}
    }

}
